import { defineComponent as _defineComponent } from 'vue'
import ContactUsLink from "@/components/landing/ContactUsLink.vue";
  import { CALENDLY_PROJECT_SALES_MARKETING_LINK } from "@/constants/calendlyLinks";
  import { useIsDesktop } from "@/features/useIsDesktop";

  const MIN_DESKTOP_WIDTH = 992;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectSalesAndMarketing',
  props: {
    features: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const { isDesktop } = useIsDesktop(MIN_DESKTOP_WIDTH);

  const props = __props;

const __returned__ = { MIN_DESKTOP_WIDTH, isDesktop, props, ContactUsLink, get CALENDLY_PROJECT_SALES_MARKETING_LINK() { return CALENDLY_PROJECT_SALES_MARKETING_LINK }, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})